import React from 'react';
import gql from 'graphql-tag';
import { Item2AdWithCspsRowContainerData } from '../schemas/rql';

import AdWithCspsRowContainer from '@reverbdotcom/commons/src/components/ads/ad_with_csps_row_container';

interface IProps {
  listing: Item2AdWithCspsRowContainerData.Fragment;
}

export const Item2AdWithCspsRowContainerFragment = gql`
  fragment Item2AdWithCspsRowContainerData on Listing {
    _id
    id
    categoryRootUuid
    categoryUuids
  }
`;

export function Item2AdWithCspsRowContainer(props: IProps) {
  const categoryUuids = Array.from(
    new Set([
      props.listing.categoryRootUuid,
      ...props.listing.categoryUuids,
    ]),
  );

  return (
    <AdWithCspsRowContainer
      categoryUuids={categoryUuids}
    />
  );
}
